<template>
  <el-container class="main-container">
    <div class="content-wrapper">
      <!-- 顶部图片 -->
      <section>
        <div class="top-banner-container">
          <img src="/static/ad2.jpg" class="top-banner">
        </div>
      </section>

      <!-- 新闻详情部分 -->
      <section class="news-detail-section">
        <div class="news-detail-container">
          <!-- 标题部分 -->
          <div class="news-title">
            {{ newInfo.title }}
          </div>

          <!-- 内容部分 -->
          <div
              v-html="newInfo.content"
              class="news-content"
          ></div>
        </div>
      </section>
    </div>
  </el-container>
</template>

<script>
import {listNews,getNews} from "@/utils/http";

export default {
  name: "App",
  props: ['t', 'currentLang'],

  data() {
    return {
      flagCn: 'https://flagcdn.com/w40/cn.png',
      flagEn: 'https://flagcdn.com/w40/gb.png',
      params:{
        eType:0
      },
      newInfo:{},
      total:0,
      currentPage: 1,
      pageSize: 10,
      newsId:0
    };
  },

  watch: {
    currentLang(newVal, oldVal) {
      this.onLangChange(newVal);
    }
  },
  mounted() {
    this.newsId = this.$route.params.id;
    this.initNew();
  },
  methods: {
    onLangChange(lang) {
      if (lang === 'zh') {
        this.params.eType = 0;
      } else {
        this.params.eType = 1;
      }
      this.initNew();
    },
    initNew() {
      getNews(this.newsId).then(response => {
        this.newInfo = response.data;
      }).catch(error => {
        console.error('获取新闻列表失败:', error);
      });
    },
  }
};
</script>

<style scoped>
/* 基础样式 */
section, div, img {
  margin: 0;
  padding: 0;
}

img {
  display: block;
  max-width: 100%;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none !important;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.content-wrapper {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.top-banner-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}

.top-banner {
  width: 100%;
  height: auto;
}

.news-detail-section {
  background-color: white;
  min-height: 694px;
  margin: 0 auto;
  padding: 30px 0;
  width: 100%;
  max-width: 1920px;
}

.news-detail-container {
  width: 60%;
  max-width: 1200px;
  margin: 0 auto;
  color: #000000;
  text-align: center;
  padding: 30px 0;
}

.news-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.news-content {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  font-size: 16px;
}

/* 高分辨率适配 */
@media screen and (min-width: 1921px) {
  .top-banner {
    width: 1920px;
    margin: 0 auto;
    display: block;
  }
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .news-detail-container {
    width: 90%;
    padding: 20px 0;
  }

  .news-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .news-content {
    padding: 0 15px;
    font-size: 15px;
  }
}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .news-detail-container {
    width: 95%;
    padding: 15px 0;
  }

  .news-title {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .news-content {
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
